const toggle = (activeValue, el) => {
    const showFieldValue = el.getAttribute('data-show-when-value-is');

    if (activeValue === showFieldValue) {
        el.setAttribute('data-show', 'true');
    } else {
        el.setAttribute('data-show', 'false');
    }
};

export const conditionalFieldEnhancer = function (el) {
    const conditionalFields = el
        .getAttribute('data-dependent-field')
        .replace(/ /g, '')
        .split(',');
    // Radio and checkbox inputs need to be checked to be considered active
    const inputValueIsActive =
        el.type === 'radio' || el.type === 'checkbox' ? el.checked : true;

    if (inputValueIsActive) {
        conditionalFields.forEach((field) => {
            toggle(el.value, document.querySelector(field));
        });
    }

    el.addEventListener('change', () => {
        conditionalFields.forEach((field) => {
            toggle(el.value, document.querySelector(field));
        });
    });
};
